<template>
  <MyResults></MyResults>
</template>

<script>
// @ is an alias to /src
import MyResults from '@/components/MyResults.vue';

export default {
  name: 'myaccount',
  components: {
    MyResults,
  },
};
</script>
